import { useState } from 'react';
import SignUpModal from '../modals/SignUpModal';

interface DemoSignUpButtonProps {
    className?: string;
    variant?: 'primary' | 'white';
}

export default function DemoSignUpButton({ className = '', variant = 'primary' }: DemoSignUpButtonProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const buttonStyles = variant === 'white'
        ? 'bg-white text-primary hover:bg-blue-50'
        : 'bg-primary text-white hover:bg-blue-700';

    return (
        <>
            <button
                onClick={() => setIsModalOpen(true)}
                className={`${buttonStyles} px-8 py-3 rounded-full font-semibold transition-colors ${className}`}
            >
                Try Demo
            </button>

            <SignUpModal 
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                formType="demo"
            />
        </>
    );
} 